import { createPortal } from "react-dom";

export const ModalSM = ({ open, handleClose, children }) => {
  return (
    <div>
      {open &&
        createPortal(
          <div
            className="fixed inset-0 z-50 w-full h-full bg-sinistri-blue/70"
            onClick={handleClose}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className={`fixed left-[50%] -translate-x-[50%] top-[50%] -translate-y-[50%] bg-white p-4 max-h-[90vh] w-full overflow-y-auto max-w-lg z-[100] rounded-lg ${
                open ? "opacity-100" : "opacity-0"
              }`}
            >
              {children}
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};
